export const getFullHtmlTitle = (htmlTitle: string, type: string) =>
  htmlTitle &&
  `${htmlTitle}${type === 'article' && htmlTitle.length < 68 ? ' - Blick' : ''}`
